module.exports = __webpack_public_path__ + "img/P12_2001-11-054-Funeral.0c9e8d58.jpg";